export const changeArr = (arr: any[], id: number, item: any) => {
    const itemId = arr.findIndex((i) => i.id === id)
    return [...arr.slice(0, itemId), item, ...arr.slice(itemId + 1, arr.length)]
}
